/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Billing_Addon_PrdInputs */

const en_billing_addon_prd = /** @type {(inputs: Billing_Addon_PrdInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.n} PRD credits`)
};

const id_billing_addon_prd = /** @type {(inputs: Billing_Addon_PrdInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.n} kredit PRD`)
};

/**
* | output |
* | --- |
* | "+{n} PRD credits" |
*
* @param {Billing_Addon_PrdInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const billing_addon_prd = /** @type {((inputs: Billing_Addon_PrdInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Addon_PrdInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_billing_addon_prd(inputs)
	return en_billing_addon_prd(inputs)
});